import { useNavigate } from 'react-router-dom';

export function HomeConnectTile() {
  const navigate = useNavigate();
  return <button type="button" className="home-add" onClick={() => navigate('/settings', { state: { from: window.location.pathname + window.location.search } })}>+ Connect another league</button>;
}

export default HomeConnectTile;
